import React, { useState } from 'react';
import './IntegrationModals.css';


const DeleteConfirmationModal = ({ isOpen, onClose, integration, onDelete }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await onDelete(integration.id);
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || 'Falha ao excluir integração');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen || !integration) return null;

    return (
        <div className="integration-modal-overlay" onClick={onClose}>
            <div className="integration-modal integration-modal-danger" onClick={(e) => e.stopPropagation()}>
                <div className="integration-modal-header">
                    <h2>Excluir Integração</h2>
                    <button className="integration-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="integration-modal-body">
                    <div className="integration-warning-box">
                        <svg className="integration-warning-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <div>
                            <h3>Tem certeza?</h3>
                            <p>
                                Você está prestes a excluir a integração <strong>"{integration.label}"</strong>.
                                Esta ação não pode ser desfeita.
                            </p>
                            <p className="integration-warning-details">
                                Tipo: {integration.name || integration.type}<br />
                                Status: {integration.status}
                            </p>
                        </div>
                    </div>

                    {error && (
                        <div className="integration-error-message">
                            {error}
                        </div>
                    )}
                </div>

                <div className="integration-modal-footer">
                    <button
                        type="button"
                        className="integration-btn integration-btn-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="integration-btn integration-btn-danger"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? 'Excluindo...' : 'Excluir Integração'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
